


































import { deepMerge } from '@empathybroker/deep-merge';
import EmpathyNow from '@empathybroker/empathy-now';

import Sortable from 'sortablejs';

import { Route } from 'vue-router';

import { mapGetters } from 'vuex';

import { UiIconButton } from '../../../components';

import { ApiEnum, DeviceEnum } from '../../../enums';

import { GuardResolveFunction } from '../../../models';

import { APP_CONSTS } from '../../../store/app/app.consts';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

import DataProvider from './DataProvider';
import OptionsProvider from './OptionsProvider';

export default {
  name: 'now',
  components: {
    UiIconButton
  },
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      fullscreen: APP_CONSTS.getters.fullscreen
    }),
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    selectedEvents(): string[] {
      if (!!this.visualizationOptions.events) {
        return this.visualizationOptions.events;
      }
      if (this.isSmallDevice) {
        return [this.sortedEvents[0]];
      }
      return this.sortedEvents.slice();
    },
    isSmallDevice: function (): boolean {
      return this.$epb.device <= DeviceEnum.SMALL_TABLET;
    }
  },
  data: function () {
    const globalEvents = ['total_queries', 'queries', 'clicks', 'no_results'];
    return {
      contextWatchDisabled: false,
      fetchDataInterval: undefined,
      globalEvents: globalEvents,
      sortedEvents: globalEvents.slice(1),
      visualizationElement: undefined,
      visualization: undefined,
      visualizationOptions: {},
      visualizationDataProvider: new DataProvider(),
      browserFullscreenEnabled: document.fullscreenEnabled,
      currentData: null
    };
  },
  methods: {
    getEventName(event: string): string {
      return {
        'total_queries': 'Total queries',
        'queries': 'Result queries',
        'clicks': 'Clicks',
        'no_results': 'No results'
      }[event];
    },
    getEventValueString(event: string): string {
      return this.getEventValue(event).toLocaleString();
    },
    getEventValue(event: string): number {
      let eventValue = 0;
      eventValue = {
        'total_queries': (this.currentData.stats.query_count + this.currentData.stats.no_results_count),
        'queries': this.currentData.stats.query_count,
        'clicks': this.currentData.stats.click_count,
        'no_results': this.currentData.stats.no_results_count
      }[event];
      return eventValue;
    },
    getEventPercentage(event: string): number {
      let eventPercentage = 0;
      const queryCount = this.getEventValue('total_queries');
      if (queryCount > 0) {
        eventPercentage = ((this.getEventValue(event) / queryCount) * 100);
      }
      return eventPercentage;
    },
    getEventPercentageString(event: string): string {
      return `${ this.getEventPercentage(event).toLocaleString().slice(0, 4) }%`;
    },
    fetchData(filtersHaveChanged = true): void {
      if (filtersHaveChanged) {
        this.$emit('updateLoading', { visible: true });
      }
      this.visualizationDataProvider.getData()
        .then((dataResponse: any) => {
          if (filtersHaveChanged) {
            this.currentData = dataResponse;
          } else {
            this.currentData.stats = dataResponse.stats;
            this.currentData.trends =
              this.visualizationDataProvider.mergeData(this.currentData.trends, dataResponse.trends, this.visualizationOptions);
          }
          this.renderVisualization(filtersHaveChanged);

          this.$emit('updateLoading', { visible: false });
        })
        .catch((error) => {
          this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
          this.$emit('updateLoading', { visible: false });
        });
    },
    renderVisualization(initializeVisualization = false): void {
      if (!this.visualization || initializeVisualization) {
        this.visualization = new EmpathyNow(this.visualizationElement, this.visualizationOptions, this.getTrimmedData());
      } else {
        this.visualization.setData(this.getTrimmedData(), this.visualizationOptions);
      }
    },
    getVisualizationOptions(): any {
      const visualizationOptions = new OptionsProvider(undefined, this.visualizationElement).get();
      visualizationOptions.events = this.selectedEvents;
      return visualizationOptions;
    },
    getTrimmedData(): any {
      const trimmedData = deepMerge({}, this.currentData);
      this.visualizationOptions.events.forEach((event: string, index: number): void => {
        if (trimmedData.trends[event]) {
          trimmedData.trends[event] = trimmedData.trends[event]
            .filter((trend: any) => trend.query.length > 1)
            .slice(0, (index === 0 ? this.visualizationOptions.nodes.main : this.visualizationOptions.nodes.secondary));
        }
      });
      return trimmedData;
    },
    onControlClick(ev: any): void {
      const event = ev.srcElement.getAttribute('event');
      if (!!event) {
        const indexOfEvent = this.visualizationOptions.events.indexOf(event);
        if (indexOfEvent >= 0) {
          if (this.visualizationOptions.events.length === 1) {
            return;
          }
          this.visualizationOptions.events.splice(indexOfEvent, 1);
        } else {
          if (this.isSmallDevice) {
            this.visualizationOptions.events = [event];
          } else {
            this.visualizationOptions.events.push(event);
            this.sortSelectedEvents();
          }
        }
        this.renderVisualization();
      }
    },
    onFullscreenClick: function (): void {
      if (this.fullscreen) {
        const { fullscreen, ...newQueryParams } = this.$route.query;
        this.$router.replace({ path: this.$route.name, query: newQueryParams });
      } else {
        this.$router.replace({ path: this.$route.name, query: { ...this.$route.query, fullscreen: 'true' } });
      }
      this.renderVisualization();
    },
    sortSelectedEvents(): void {
      this.selectedEvents.sort((ev1: string, ev2: string) => (this.sortedEvents.indexOf(ev1) - this.sortedEvents.indexOf(ev2)));
    }
  },
  mounted: function (): void {
    this.visualizationElement = (this.$refs.visualizationElement as HTMLElement);
    this.visualizationOptions = this.getVisualizationOptions();

    this.fetchData();
    this.fetchDataInterval = setInterval((): void => {
      if (document.visibilityState === 'visible') {
        this.fetchData(false);
      }
    }, 30000);

    Sortable.create(this.$refs.controlsContainerElement, {
      handle: '.now-query-wrapper__control-handler',
      animation: 500,
      ghostClass: 'now-query-wrapper__control--ghost',
      onUpdate: (ev) => {
        const movedEvent = this.sortedEvents.splice(ev.oldIndex, 1)[0];
        this.sortedEvents.splice(ev.newIndex, 0, movedEvent);
        this.sortSelectedEvents();

        this.renderVisualization();
      }
    });
    window.addEventListener('resize', () => {
      this.visualization.destroy();
      this.visualizationOptions =
        Object.assign({}, new OptionsProvider(undefined, this.visualizationElement).get(), { events: this.selectedEvents });
      this.renderVisualization(true);
    });
  },
  beforeDestroy: function (): void {
    clearInterval(this.fetchDataInterval);

    this.visualization.destroy();
  },
  beforeRouteLeave: function (to: Route, from: Route, next: GuardResolveFunction) {
    this.contextWatchDisabled = true;
    next();
  },
  watch: {
    context: {
      handler: function () {
        if (!this.contextWatchDisabled) {
          this.fetchData();
        }
      },
      deep: true
    }
  }
};

